/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IERC1155Receiver__factory } from "./IERC1155Receiver__factory";
